export const partnershipValues: string[] = [
  'cyberchile',
  'dmpodcast',
  'ccxce',
  'ccxce2month',
  'ccxce1month',
  'ccxce3month',
]
